import xhr from 'xhr';

/**
 * Base histórica: estudiantes de las plataformas anteriores (KLAZIA antigua, Integrado, Bachillerato desde casa).
 * Endpoints en klazia-api: src/api/historical-base. Admin y supervisor_admin consultan y editan.
 */

export const READ_ROLES = ['admin', 'supervisor_admin'];
export const EDIT_ROLES = ['admin', 'supervisor_admin'];

export const SOURCE_LABEL = {
  antigua: 'KLAZIA antigua',
  integrado: 'Integrado',
  casa: 'Desde casa',
};

export const SOURCE_TONE = { antigua: 'blue', integrado: 'purple', casa: 'green' };

export const STATUS = {
  registrado: { label: 'Registrado', color: '#94A3B8' },
  matriculado: { label: 'Matriculado', color: '#574feb' },
  estudiando: { label: 'Estudiando', color: '#574feb' },
  promocionado: { label: 'Promocionado', color: '#3B82F6' },
  graduado: { label: 'Graduado', color: '#10B981' },
  retirado: { label: 'Retirado', color: '#EF4444' },
};

// «Por revisar» va en el selector de estados, pero es una marca aparte (review_reason): el estado real se conserva.
export const REVIEW_STATUS = { value: 'revisar', label: 'Por revisar' };

export const SOURCE_OF_RECORD = {
  archivo: { label: 'Del archivo', color: 'green.600' },
  editada: { label: 'Editada', color: 'blue.600' },
  agregada: { label: 'Agregada', color: 'purple.600' },
};

export const errorMessage = (e) => e?.response?.data?.error?.message || 'No se pudo completar la acción.';

export const formatScore = (v) => (v === null || v === undefined ? '' : Number(v).toFixed(1).replace('.', ','));
export const formatMoney = (v) => (v === null || v === undefined ? '—' : `$${Number(v).toLocaleString('es-CO')}`);
export const formatDate = (d) => {
  if (!d) return '—';
  const [y, m, day] = String(d).slice(0, 10).split('-');
  return `${day}/${m}/${y}`;
};

function query(params) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && v !== false) qs.append(k, v);
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export async function getHistoricalOptions() {
  const { data } = await xhr.get('/historical-base/options');
  return data;
}

export async function getHistoricalSummary(params) {
  const { data } = await xhr.get(`/historical-base/summary${query(params)}`);
  return data;
}

export async function getHistoricalStudents(params) {
  const { data } = await xhr.get(`/historical-base/students${query(params)}`);
  return data;
}

export async function getHistoricalStudent(id) {
  const { data } = await xhr.get(`/historical-base/students/${id}`);
  return data;
}

export async function updateHistoricalStudent(id, body) {
  const { data } = await xhr.put(`/historical-base/students/${id}`, body);
  return data;
}

/** No borra: lo marca como eliminado y lo oculta (con sus notas y pagos). Queda en Auditoría. */
export async function deleteHistoricalStudent(id, body) {
  // El API no lee el cuerpo de un DELETE: el motivo va en la URL.
  const { data } = await xhr.delete(`/historical-base/students/${id}${query({ reason: body?.reason })}`);
  return data;
}

/** Eliminar varios (casillas de la tabla). Igual que uno: se marcan y se ocultan. */
export async function deleteHistoricalStudents(ids, reason) {
  const { data } = await xhr.post('/historical-base/students/bulk-delete', { ids, reason });
  return data;
}

export async function createHistoricalGrade(studentId, body) {
  const { data } = await xhr.post(`/historical-base/students/${studentId}/grades`, body);
  return data;
}

export async function updateHistoricalGrade(id, body) {
  const { data } = await xhr.put(`/historical-base/grades/${id}`, body);
  return data;
}

export async function createHistoricalPayment(studentId, body) {
  const { data } = await xhr.post(`/historical-base/students/${studentId}/payments`, body);
  return data;
}

export async function updateHistoricalPayment(id, body) {
  const { data } = await xhr.put(`/historical-base/payments/${id}`, body);
  return data;
}
